import { atom, useAtom } from "jotai";

const sdgOptionsAtom = atom<{ label: string; value: number }[]>([]);

function useSdgOptions() {
  const [sdgOptions, setSdgOptions] = useAtom(sdgOptionsAtom);
  return {
    sdgOptions,
    setSdgOptions,
  };
}

export default useSdgOptions;
